import React, { FunctionComponent } from 'react';
import { ShowIf } from './ShowIf';

export interface QuestionGroupProps {
    trigger?: boolean;
}

interface Child {
    props: {
        selector: string;
        children: React.ReactNode;
        showIf?: boolean;
        style?: string;
    };
    type: {
        name: string;
    };
}

export const QuestionGroup: FunctionComponent<QuestionGroupProps> = ({ trigger, children }) => {
    const childElements = React.Children.toArray(children);
    const childTypes = childElements.map((child: Child) => child.type.name);
    const uniqChildTypes = [...new Set(childTypes)];
    const unMinify =
        uniqChildTypes.length > 2
            ? {
                  // if the order of html structure fails here we are in trouble.
                  Legend: uniqChildTypes[0],
                  Question: uniqChildTypes[1],
                  IfNeedsAdditional: uniqChildTypes[2],
              }
            : {
                  // legend was not passed to question group
                  Question: uniqChildTypes[0],
                  IfNeedsAdditional: uniqChildTypes[1],
              };
    // the <Legend /> child
    const [legend] = childElements.filter((child: Child) => child.type.name === unMinify.Legend);
    // the <Question /> children
    const questions = childElements.filter((child: Child) => child.type.name === unMinify.Question);
    // the <IfNeedsAdditional /> child
    const [ifNeedsAdditional] = childElements.filter((child) => child['type'].name === unMinify.IfNeedsAdditional);
    /**
     * the <Question /> array that needs to be shown if the Business Rule is met
     * @see ifNeedsAdditionalQuestions
     */
    const ifNeedsAdditionalQuestions = React.Children.map(ifNeedsAdditional?.['props']?.children, (e) =>
        React.cloneElement(e, { required: true })
    );

    return (
        <div className='form-group visual-group'>
            <fieldset>
                {legend}
                <ol type='a'>
                    {questions.map((q: Child, i) =>
                        q.props.showIf !== undefined ? (
                            <ShowIf
                                key={i}
                                showIf={q.props.showIf}
                            >
                                <li>{q}</li>
                            </ShowIf>
                        ) : (
                            <li key={i}>{q}</li>
                        )
                    )}
                </ol>
                {trigger && ifNeedsAdditionalQuestions}
            </fieldset>
        </div>
    );
};
